<a #toggle class="ds-dropdown-selected-option"
   (click)="showDropDown = !showDropDown"
   [ngClass]="{'ds-dropdown-toggled': showDropDown, 'disabled': dsDropdownDisabled}"
   [ngStyle]="{width: dsDropdownWidth, height: dsDropdownHeight}">
  <p class="ds-dropdown-label no-seleced" [innerHTML]="dsDropDownTitle" *ngIf="!selectedOptions?.length"></p>
  <p class="ds-dropdown-label selected" *ngIf="!!selectedOptions">
    <span *ngFor="let selectedOption of selectedOptions; let index = index">
      {{ selectedOption?.label + (index !== selectedOptions?.length - 1 ? ', ' : '') }}
    </span>
  </p>
  <i class="db-icon db-icon-ds-arrow-small"></i>
</a>
<div class="ds-multiselect mt5" *ngIf="!!showDropDown">
  <div>
    <ul>
      <li *ngFor="let option of dsDropdownOptions" (click)="toggleSelection(option)">
        <a class="ds-dropdown-option"
           [ngClass]="{'ds-dropdown-option-selected': selectedOptions.includes(option)}">
          <div>
            <input class="ds-checkbox" type="checkbox" (click)="toggleSelection(option)" [checked]="selectedOptions.includes(option)" id="checkbox_{{option?.value}}">
            <label for="checkbox_{{option?.value}}" class="green"></label>
          </div>
          <p class="ds-dropdown-option-label" [innerHTML]="option?.label"></p>
        </a>
      </li>
    </ul>
  </div>
</div>
